// Shared plan metadata for the four EVERMIN tiers.
// Backend (/membership/tiers) remains the source of truth for feature lists;
// this lightweight map powers the limit-reached upgrade modal and quick lookups.
export const PLAN_ORDER = ["free", "basic", "plus", "pro"];

export const PLANS = {
  free: {
    id: "free", price: 0, ai: 10,
    name: { en: "Free", hi: "फ्री" },
    tagline: { en: "Everyday help, always free.", hi: "रोज़मर्रा की मदद, हमेशा मुफ़्त।" },
  },
  basic: {
    id: "basic", price: 199, ai: 30,
    name: { en: "Basic", hi: "बेसिक" },
    tagline: { en: "Everyday essentials", hi: "रोज़मर्रा की ज़रूरतें" },
  },
  plus: {
    id: "plus", price: 299, ai: 60,
    name: { en: "Plus", hi: "प्लस" },
    tagline: { en: "Everyday power", hi: "रोज़मर्रा की ताकत" },
  },
  pro: {
    id: "pro", price: 499, ai: 100,
    name: { en: "Pro", hi: "प्रो" },
    tagline: { en: "Maximum everyday use", hi: "अधिकतम रोज़मर्रा उपयोग" },
  },
};

// Tiers a user can upgrade to from their current tier (never "free").
export function higherTiers(tier) {
  const i = PLAN_ORDER.indexOf(tier);
  if (i < 0) return ["basic", "plus", "pro"];
  return PLAN_ORDER.slice(i + 1).filter((t) => t !== "free");
}
